import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import api from "../services/api"
import { toast } from 'react-toastify'

export type CandidataType = {
    id: string
    nome: string
    cidade: string
    foto: string
    topfan: string
}

export function useCandidatas() {
    const history = useNavigate()
    const [candidatas, setCandidatas] = useState<CandidataType[]>([])
    const [votos, setVotos] = useState<number | null>(null)

    useEffect(() => {
        api.get('candidatas/listCandidatas')
        .then((response) => {
            if(response){
                if(response.data.dados){
                    setCandidatas(response.data.dados)
                }
                setVotos(Number(response.data.votos))
            }else{
                localStorage.clear()
                toast.warning("Sessão Expirada")
                history('/login')
            }
        })
        .catch((e) =>{
            if (e.response) {
                localStorage.clear()
                toast.warning("Sessão Expirada, faça Login novamente")
                history('/login')
            }
            
        })
    }, [history])
    return {candidatas, votos}

}